export const formSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    sections: {
      type: 'array',
      title: 'Sections',
      items: {
        type: 'object',
        properties: {
          title: {
            type: 'string',
            title: 'Title',
          },
          content: {
            type: 'string',
            title: 'Content',
          },
          file: {
            type: 'string',
            format: 'data-url',
            title: 'Image'
          },
        },
        required: ['title', 'content'],
      },
    },
  },
};
export const uiSchema = {
  sections: {
    items: {
      content: {
        "ui:widget": "textarea",
        "ui:options": {
          "rows": 2
        }
      }
    }
  }
}
